import React from 'react';

const HomePage = () => {


    return (
            <h1> HomePage </h1>

    );
};

export {HomePage};